import KVLineComponent from './KVLine.component';
import KVLineLoader from './KVLineLoader';

const KVLine = Object.assign(KVLineComponent, { Loading: KVLineLoader });

export default KVLine;
